import { render, staticRenderFns } from "./HomeworkAnalysis.vue?vue&type=template&id=0916fc33&scoped=true&"
import script from "./HomeworkAnalysis.vue?vue&type=script&lang=js&"
export * from "./HomeworkAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkAnalysis.vue?vue&type=style&index=0&id=0916fc33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0916fc33",
  null
  
)

export default component.exports